const defaultCacheTime = 1000 * 60 * 5;

export const courseQueryStaleTime = defaultCacheTime;
export const courseEventsQueryStaleTime = defaultCacheTime;
